<template>
  <div>
    <v-layout v-if="isStaff" column justify-center align-center >
      <v-flex xs6>
        <v-alert type="success" :value="true">
          <h3>
            {{ settings.staff_message }}
          </h3>
        </v-alert>
      </v-flex>
    </v-layout>
    <v-layout v-else-if="isGraduate" column justify-center align-center >
      <v-flex xs6>
        <v-alert type="success" :value="true">
          <h3>
            {{ settings.graduate_message }}
          </h3>
        </v-alert>
      </v-flex>
    </v-layout>
    <v-card v-else>
      <v-card-text>
        <v-layout row justify-center align-center>
          <v-flex xs6 px-2>
            <v-layout mt-2 mb-4 row wrap justify-center align-center>
              <v-flex xs12>
                <div class="body-2">
                  {{ service_selected.description }}
                </div>
              </v-flex>
            </v-layout>
            <v-layout v-if="students.length > 0" row justify-center align-center>
              <v-flex xs12>
                <v-select
                  :items="students"
                  v-model="student"
                  label="¿ Quien utiliza el servicio ?"
                  v-validate="'required'"
                  data-vv-as="¿ Quien utiliza el servicio ?"
                  data-vv-name="student"
                  data-vv-scope="student"
                  :error-messages="errors.collect('student')"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-card-text v-if="students.length > 0 && service_selected.id">
              <v-layout column wrap justify-center align-center v-if="service_selected.multiple_services">
                <v-flex xs3>
                  <v-text-field
                    name="quantity"
                    label="Cantidad"
                    v-model="quantity"
                    v-validate="'required'"
                    type="number"
                    min="1"
                    :max="service_selected.max_services"
                    :error-messages="errors.collect('quantity')"
                    style="width: 180px"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 v-if="invalidQuantity">
                  <v-alert
                    :value="true"
                    type="info"
                  >
                    La cantidad seleccionada debe estar entre 1 y {{ service_selected.max_services }}
                  </v-alert>
                </v-flex>
                <v-flex xs6 v-if="notAvailable">
                  <v-alert
                    :value="true"
                    type="info"
                  >
                    Solo hay {{ service_selected.available_services }} servicios disponibles
                  </v-alert>
                </v-flex>
              </v-layout>
              <v-layout column wrap justify-center align-center v-if="service_selected.needs_payment">
                <v-flex xs6 v-if="isInPortfolio">
                  <v-alert
                    :value="true"
                    type="info"
                  >
                    En el momento no es posible adquirir el servicio seleccionado, por favor enviar un correo electrónico a cartera@columbus.edu.co. Muchas gracias.
                  </v-alert>
                </v-flex>
                <v-flex class="mb-4 mt-4" xs6>
                  <span class="title">Precio: </span>
                  <v-chip class="title" color="secondary" text-color="white">
                    <v-avatar class="green darken-4">$</v-avatar>
                    {{ formatNumber(service_selected.total_price) }}
                  </v-chip>
                </v-flex>
                <v-flex xs6>
                  <v-btn :loading="loading_btn" :disabled="loading_btn || isInPortfolio || invalidQuantity || notAvailable" @click="payTc" color="primary">{{ $t('admissions.pay') }}</v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-center v-else>
                <v-btn
                  @click="getService"
                  :loading="loading_btn"
                  :disabled="invalidQuantity || notAvailable"
                  color="primary">{{ $t('admissions.add') }}</v-btn>
              </v-layout>
            </v-card-text>
          </v-flex>
          <v-flex xs3 px-2 v-if="service_selected.image">
            <v-img
              :src="service_selected.image"
              width="100%"
            >
            </v-img>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text>
        <v-layout row wrap justify-center>
          <v-flex xs12>
            <v-data-table
              :headers="headers"
              :items="pending_services"
              class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-center">{{ props.item.service.name }}</td>
                <td class="text-xs-center">{{ props.item.student ? props.item.student.full_name : props.item.user.name }}</td>
                <td class="text-xs-center">${{ formatNumber(props.item.service.price) }}</td>
                <td class="text-xs-center">{{ props.item.quantity }}</td>
                <td class="text-xs-center">${{ formatNumber(props.item.payment.platform_payment_total) }}</td>
                <td class="text-xs-center">
                  <span v-if="props.item.needs_payment == 1">
                    {{ props.item.payment.payment_type }}
                  </span>
                  <span v-else>
                    {{ $t('admissions.without-payment') }}
                  </span>
                </td>
                <td class="text-xs-center">
                  <span v-if="props.item.needs_payment == 1">
                    {{ $t(`enrollments.payment_status.${props.item.payment.payment_state}`) }}
                  </span>
                  <span v-else>
                    {{ $t('admissions.without-added') }}
                  </span>
                </td>
                <td class="text-xs-center">
                  <div v-if="props.item.needs_payment == 1">
                    <v-btn
                      v-if="props.item.payment.payment_state !== 'APPROVED' && props.item.payment.payment_state !== 'OK'"
                      color="error"
                      @click="cancel(props.item.id)">{{ $t('admissions.cancel') }}</v-btn>
                    <v-btn
                      :loading="validate_btn_loading == props.item.payment_id"
                      :disabled="validate_btn_loading == props.item.payment_id"
                      v-if="props.item.payment.payment_state === 'PENDING'"
                      color="info"
                      @click="validatePayment(props.item.payment.id)">{{ $t('admissions.validate_payment') }}</v-btn>
                    <v-btn
                      v-if="props.item.payment.payment_state !== 'APPROVED' && props.item.payment.payment_state !== 'OK' && props.item.payment.payment_state !== 'PENDING'"
                      color="error"
                      outline
                      @click="paymentProof(props.item.payment, props.item.service.name, props.item.quantity, props.item.token, props.item.service.format, props.item.service.image)"
                      >{{ $t('admissions.payment_proof') }}</v-btn>
                    <v-btn
                      v-if="props.item.payment.payment_state === 'APPROVED' || props.item.payment.payment_state === 'OK'"
                      color="success"
                      @click="paymentProof(props.item.payment, props.item.service.name, props.item.quantity, props.item.token, props.item.service.format, props.item.service.image)"
                      >{{ $t('admissions.payment_proof') }}</v-btn>
                  </div>
                  <div v-else>
                    <v-btn
                      v-if="props.item.service.has_next_step == 1"
                      @click="nextStepConfirmation(props.item.id, props.item.service.next_step, props.item.service.next_step_name)"
                      color="secondary">
                      {{ props.item.service.next_step_name }}
                    </v-btn>
                  </div>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text>
        <v-layout row wrap justify-center align-center mb-3 mt-2>
          <v-flex xs1>
            <v-img contain :src="`${appUrl}/storage/img/payment/pse-min.jpg`"></v-img>
          </v-flex>
          <v-flex xs1>
            <v-img contain :src="`${appUrl}/storage/img/payment/visa-min.webp`"></v-img>
          </v-flex>
          <v-flex xs1>
            <v-img contain :src="`${appUrl}/storage/img/payment/Mastercard-min.jpg`"></v-img>
          </v-flex>
          <v-flex xs1>
            <v-img contain :src="`${appUrl}/storage/img/payment/diners-min.jpg`"></v-img>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-layout row justify-center>
      <v-btn flat @click="goToPrevStep">{{ $t(`enrollments.back`) }}</v-btn>
      <v-btn v-if="students.length == 0 || isGraduate || isStaff" @click="goToNextStep" color="primary">{{ $t(`enrollments.next`) }}</v-btn>
    </v-layout>
    <v-dialog
      v-model="payment_dialog"
      width="600"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline primary white--text"
          primary-title
        >
          {{ $t('payments.payment_text_title') }}
        </v-card-title>

        <v-card-text v-html="$t('payments.payment_text')">
        </v-card-text>

      </v-card>
    </v-dialog>
    <v-dialog
        v-model="payment_detail_dialog"
        width="350"
        persistent
      >
      <payment-proof
        :payment="payment_to_show"
        :payment_detail="payment_detail"
        :payment_quantity="payment_quantity"
        :payment_token="payment_token"
        :payment_format="payment_format"
        :payment_image="payment_image"
      >
      </payment-proof>
      <v-card class="pt-3">
        <v-layout row justify-center align-center>
          <v-btn
            color="primary"
            @click="payment_detail_dialog = false"
          >
            {{ $t('close') }}
          </v-btn>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import paymentProof from './../payment/proof'
  export default {
    name: 'services-buy-view',
    components: {
      'payment-proof': paymentProof,
    },
    props: {
      family: {
        type: [Array],
        required: true
      },
      settings: {
        type: [Object],
        required: true
      },
      id_pago: {
        type: [String],
        required: false,
        default: null
      }
    },
    data() {
      return {
        appUrl: window.config.appUrl,
        all_services: [],
        services: [],
        service: '',
        service_selected: {},
        payment_dialog: false,
        loading_btn: false,
        headers: [
          { text: 'Nombre', align: 'center', value: 'service.name' },
          { text: 'Usuario', align: 'center', value: 'service.user.name' },
          { text: 'Precio', align: 'center', value: 'service.price' },
          { text: 'Cantidad', align: 'center', value: 'service.quantity' },
          { text: 'Total', align: 'center', value: 'payment.platform_payment_total' },
          { text: 'Metodo', align: 'center', value: 'payment.payment_type' },
          { text: 'Estado', align: 'center', value: 'payment.payment_state' },
          { text: 'Acciones', align: 'center', value: 'actions' },
        ],
        pending_services: [],
        validate_btn_loading: false,
        payment_detail_dialog: false,
        payment_to_show: {},
        payment_detail: '',
        payment_quantity: 1,
        payment_token: '',
        payment_format: '',
        payment_image: '',
        go_dialog: false,
        user_service_id: '',
        next_step: '',
        next_step_name: '',
        student: '',
        quantity: 1,
        students: [],
        all_students: [],
        user_name: '',
        portfolio: [],
        isInPortfolio: false,
        invalidQuantity: false,
        notAvailable: false,
        isStaff: false,
        isGraduate: false,
        family_info: []
      }
    },
    created () {
      this.init();
    },
    watch: {
      service(newValue, oldValue) {
        if (newValue) {
          this.service_selected = this.all_services.find(service => service.id == newValue)
          this.service_selected.total_price = this.service_selected.price
          this.quantity = 1

          this.setStudents()

          return
        }
        this.service_selected = {}
      }
    },
    methods: {
      init() {
        this.family_info = this.family
        this.isStaff = this.family_info[0].family.employee ? true : false;
        this.isGraduate = this.family_info[0].guardian1_graduate == 'Si' || this.family_info[0].guardian2_graduate ==  'Si' ? true : false;

        axios.get(`/api/school/services/available/${this.settings.service_id}`)
          .then(resp => {
            if (resp.status === 200) {
              const services = Object.values(resp.data.services)
              this.all_services = services
              this.pending_services = resp.data.pending_services
              this.all_students = this.family_info

              if (this.id_pago) {
                this.validateCallbackPayment();
              }

              this.service = this.settings.service_id
            }
          })
      },
      formatNumber(number) {
        if(!number || typeof number === 'undefined') {
            return 0;
        } else {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
      },
      async validForm() {
        return await this.$validator.validateAll('student');
      },
      setStudents() {
        this.students =
            this.all_students
            .filter(student => {
              let pass = true
              if (this.service_selected.one_payment == 0) {
                return true
              }

              student.services_paid.forEach(service_paid => {
                if (service_paid.service_id === this.service_selected.id) {
                  pass = false
                }
              })

              return pass

            })
            .map(student => {
              return {
                value: `${student.id}-${student.siesa_sucursal}`,
                text: (!student.siesa_sucursal || !student.siesa_tercero_id || !student.siesa_tercero_id_type) ? student.full_name + ' (Faltan datos del estudiante)' : student.full_name,
                siesa_sucursal: student.siesa_sucursal,
                siesa_tercero_id: student.siesa_tercero_id,
                siesa_tercero_id_type: student.siesa_tercero_id_type,
                disabled: !student.siesa_sucursal || !student.siesa_tercero_id || !student.siesa_tercero_id_type
              }
            })
      },
      payTc() {
        const service_id = this.service
        const total = this.service_selected.total_price
        const student = this.student
        const quantity = this.quantity
        this.loading_btn = true
        const admissions = true
        this.$validator.validateAll('student').then(valid => {
          if (valid) {
            axios.post('/api/school/service/pay/tc', { service_id, total, student, quantity, admissions })
              .then(resp => {
                if (resp.status === 200) {
                  if (resp.data.error) {
                    this.$store.dispatch('responseMessage', {
                      type: 'error',
                      text: resp.data.message,
                      title: this.$t('error_alert_text'),
                      modal: true
                    })
                    this.loading_btn = false
                    return;
                  }
                  this.payment_dialog = true;
                  setTimeout(() => {
                    window.location = resp.data.url;
                  }, 5000);
                } else {
                  this.$store.dispatch('responseMessage', {
                    type: 'error',
                    text: this.$t('extracurriculares.pay_reserve.payment_error'),
                    title: this.$t('error_alert_text'),
                    modal: true
                  })
                }
                this.loading_btn = false
              })
              .catch(error => {
                this.loading_btn = false
              })
          }
        })
      },
      getService() {
        const service_id = this.service
        const student = this.student
        const quantity = this.quantity
        this.$validator.validateAll('student').then(valid => {
          if (valid) {
            axios.post('/api/school/service/pay/no_pay', { service_id, student, quantity })
              .then(resp => {
                  if (resp.status === 200) {
                    this.service = ''
                    this.init()
                  }
                }
              )
              .catch(error => {
                this.loading_btn = false
              })
          }
        })
      },
      cancel(user_service_id) {
        axios.post('/api/school/service/cancel', { user_service_id })
          .then(resp => {
            if (resp.status === 200) {
              this.pending_services = this.pending_services.filter(user_service => user_service.id !== user_service_id)
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
      async validatePayment(payment_id) {
        this.validate_btn_loading = payment_id
        await axios.post('/api/school/service/validate_payment', { payment_id, admissions: true })
          .then(resp => {
            if (resp.status === 200) {
              axios.get('/api/admissions/get_admissions_info')
                .then(resp => {
                  if (resp.status === 200) {
                    this.family_info = resp.data
                    this.all_students = this.family_info
                    this.setStudents()
                  }
                })
                .catch(error => console.log(error))
              this.init()
              this.validate_btn_loading = false
            }
          })
          .catch(error => {
            this.validate_btn_loading = false
            console.log(error)
          })
      },
      validateCallbackPayment() {
        const idPago = this.id_pago
        this.id_pago = null
        const serviceToValidate = this.pending_services
          .find(service => service.payment.payment_id == idPago)
        this.validatePayment(serviceToValidate.payment_id)
      },
      paymentProof(payment, service_name, quantity, token, format, image) {
        this.payment_detail_dialog = true
        this.payment_to_show = payment
        this.payment_detail = service_name
        this.payment_quantity = quantity
        this.payment_token = token
        this.payment_format = format
        this.payment_image = image
      },
      async goToNextStep() {
        await this.updateStep(4)
        this.$emit('goToNextStep', 4, this.family_info)
      },
      goToPrevStep() {
        this.$emit('goToPrevStep', 2)
      },
      async updateStep(step) {
        const payload = {
          entry_id : this.family_info[0].id,
          step,
          quote_id : this.settings.quote_id
        }
        await axios.put('/api/admissions/update_step', payload)
          .then(resp => {
            if (resp.status === 200) {
              this.family_info[0] = resp.data.updated
            }
          })
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/admissions/admissions_step3.vue